import { render, staticRenderFns } from "./lecZhiboList.vue?vue&type=template&id=278e2658&scoped=true"
import script from "./lecZhiboList.vue?vue&type=script&lang=js"
export * from "./lecZhiboList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e2658",
  null
  
)

export default component.exports